module.exports = __webpack_public_path__ + "question_mark.d732904d582ce44fb10c2947745248c3.svg";